/**
 * AI platform bootstrap.
 *
 * Registers the production providers exactly once, at app startup.
 * Adding Gemini or Claude later means adding one adapter + one line here —
 * no feature code changes.
 */

import { hasProvider, registerProvider } from './registry';
import { aiSettings } from './settings';
import { OpenAIProvider } from './providers/OpenAIProvider';

let bootstrapped = false;

export function bootstrapAIPlatform(): void {
  if (bootstrapped) return;
  bootstrapped = true;

  if (!hasProvider('openai')) {
    registerProvider(new OpenAIProvider());
  }

  // Overlay the admin control-plane settings (provider/model/feature choices)
  // on top of the build-time config. Cached values apply synchronously; the
  // shared row is fetched in the background and re-applied when it lands.
  aiSettings.apply();
  void aiSettings.load();
}

/** Test helper: allow a re-run after `resetProviders()`. */
export function resetAIBootstrap(): void {
  bootstrapped = false;
}
